import React from "react";

function formatCurrency(num) {
  if (num === null || num === undefined) return "\u2014";
  const sign = num < 0 ? "-" : "";
  return `${sign}R$ ${Math.abs(num).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

/**
 * Bloco "ficha" (label à esquerda, valor mono à direita) — reproduz um
 * bloco da planilha IMPOSTOS (ex.: "RECEITA PLCOM", "DESPESAS", "APURAÇÃO")
 * linha a linha, na mesma ordem/rótulos do Excel. `tag` reproduz anotações
 * da planilha ("a crédito", "Débito", "A PAGAR"); `destaque` marca linhas de
 * total/resultado (mesmo efeito visual da linha de total do Excel).
 */
export default function LedgerBlock({ titulo, linhas, fill = false }) {
  return (
    <div className={`ledger-block ${fill ? "is-fill" : ""}`}>
      <h4>{titulo}</h4>
      <div className="ledger-rows">
        {linhas.map((linha, i) => (
          <div className={`ledger-row ${linha.destaque ? `is-${linha.destaque}` : ""}`} key={i}>
            <span className="ledger-label">{linha.label}</span>
            {linha.tag && <span className={`ledger-tag ${linha.tag.toLowerCase().includes("créd") ? "credito" : linha.tag.toLowerCase().includes("déb") ? "debito" : "pagar"}`}>{linha.tag}</span>}
            <span className="ledger-value">{formatCurrency(linha.valor)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
